/* eslint-disable unused-imports/no-unused-vars */
import { Box } from '@mui/material';
import SectionFlowEditor from '../components/SectionFlowEditor';
import './add-template.scss';
import { ITemplateFormProps } from '../utils/types';

const AddTemplate: React.FC<ITemplateFormProps> = ({ modulePath, module, type }) => {
  return (
    <Box sx={{ height: 'calc(100vh - 64px)', bgcolor: 'grey.50' }}>
      <SectionFlowEditor modulePath={modulePath} module={module} type={type} />
    </Box>
  );
};

export default AddTemplate;